import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class UserRecentEndpointService {
  readonly #service = inject(ServicesService);

  createRecentMethod() {
    return this.#service.userService('recent/method');
  }

  createRecentArrangement(methodSlug: string) {
    return this.#service.userService(`recent/method/${methodSlug}/arrangement`);
  }

  createRecentResource(arrangementCode: string) {
    return this.#service.userService(
      `recent/arrangement/${arrangementCode}/resource`,
    );
  }

  getRecentMethods() {
    return this.#service.userService('recent/method');
  }

  getRecentArrangements(methodSlug: string) {
    return this.#service.userService(`recent/method/${methodSlug}/arrangement`);
  }

  removeRecents() {
    return this.#service.userService('recent');
  }
}
